// hooks/useAnnouncement.js
import { useState } from 'react';
import announcementAPI from '../api/announcementAPI';

const useAnnouncement = () => {
  // console.log('🔍 announcementAPI loaded:', announcementAPI);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendAnnouncement = async (announcementData) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await announcementAPI.sendAnnouncement(announcementData);
      setIsLoading(false);
      return response;
    } catch (err) {
      console.error('Send announcement error:', err);
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  };

  const sendAdminAnnouncement = async (announcementData) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await announcementAPI.sendAdminAnnouncement(announcementData);
      setIsLoading(false);
      return response;
    } catch (err) {
      console.error('Send admin announcement error:', err);
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  };

  const getAnnouncementHistory = async (instructorId, page = 1, limit = 20) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await announcementAPI.getAnnouncementHistory(instructorId, page, limit);
      setIsLoading(false);
      return response;
    } catch (err) {
      console.error('Get announcement history error:', err);
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  };

  const getAdminAnnouncementHistory = async (page = 1, limit = 20) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await announcementAPI.getAdminAnnouncementHistory(page, limit);
      setIsLoading(false);
      return response;
    } catch (err) {
      console.error('Get admin announcement history error:', err);
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  };

  const getStudentAnnouncements = async (studentId, page = 1, limit = 20) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await announcementAPI.getStudentAnnouncements(studentId, page, limit);
      setIsLoading(false);
      return response;
    } catch (err) {
      console.error('Get student announcements error:', err);
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  };

  const getUnreadAnnouncementCount = async (userId) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await announcementAPI.getUnreadAnnouncementCount(userId);
      setIsLoading(false);
      return response;
    } catch (err) {
      console.error('Get unread announcement count error:', err);
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  };

  const markAnnouncementAsRead = async (announcementId, studentId) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await announcementAPI.markAnnouncementAsRead(announcementId, studentId);
      setIsLoading(false);
      return response;
    } catch (err) {
      console.error('Mark announcement as read error:', err);
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  };

  const deleteAnnouncement = async (announcementId, instructorId) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await announcementAPI.deleteAnnouncement(announcementId, instructorId);
      setIsLoading(false);
      return response;
    } catch (err) {
      console.error('Delete announcement error:', err);
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  };

  return {
    sendAnnouncement,
    sendAdminAnnouncement,
    getAnnouncementHistory,
    getStudentAnnouncements,
    getUnreadAnnouncementCount,
    markAnnouncementAsRead,
    deleteAnnouncement, 
    getAdminAnnouncementHistory,  
    getAdminAnnouncementHistory,
    isLoading,
    error
  };
};

export default useAnnouncement;